import { MovieOpenSettingsOutlineIcon } from './MovieOpenSettingsOutlineIcon';

/**
 * author: Colton Wiscombe
 * id C481209F-DE3F-4D25-8C4F-0D21CB8D3385
 * name movie-open-settings-outline
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/movie-open-settings-outline.svg
 * tags
 * - Video / Movie 
 * - Settings 
 */
export const FilmOpenSettingsOutlineIcon = MovieOpenSettingsOutlineIcon;
export default FilmOpenSettingsOutlineIcon